import { ILogReportFilter } from '../screens/report/types/report-log.type';
// import IconVesselOnline from '../../../assets/icons/dashboard/icon-vessel-online-map.png';
// import IconVesselOffline from '../../../assets/icons/dashboard/icon-vessel-offline-map.png';
// import IconVesselWaiting from '../../../assets/icons/dashboard/icon-vessel-waiting-map.png';
import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

enum VesselStatus {
  ONLINE = 'Online',
  OFFLINE = 'Offline',
  WAITING_DATA = 'Waiting Data',
}

const getVesselStatus = (
  lastDataGPS: any,
  dataSource: 'GSM' | 'SATELLITE',
  filter?: ILogReportFilter,
  assetName?: string
) => {
  let dataStatus: VesselStatus = VesselStatus.OFFLINE;
  let currentTime = dayjs().unix();
  let lastDataTimestamp = lastDataGPS?.hasOwnProperty('timestamp')
    ? lastDataGPS.timestamp
    : null;
  // if (filter) {
  //   const dateNow = dayjs().date();
  //   const filterStartDate = dayjs(filter.startAt * 1000).date();
  //   console.log({ filter });
  //   if (dateNow !== filterStartDate) {
  //     currentTime = dayjs(lastDataTimestamp * 1000).unix();
  //   }
  // }

  const diff = currentTime - lastDataTimestamp;
  const MAX_OFFLINE = 86400; // 24 jam
  const WAITING_LIMIT = dataSource === 'SATELLITE' ? 7200 : 600; // 2 jam / 10 menit

  if (diff === 0) {
    dataStatus = VesselStatus.ONLINE;
  } else if (diff <= MAX_OFFLINE) {
    dataStatus =
      diff > WAITING_LIMIT ? VesselStatus.WAITING_DATA : VesselStatus.ONLINE;
  } else {
    dataStatus = VesselStatus.OFFLINE;
  }

  // console.log('vessel status', {
  //   assetName,
  //   currentTime,
  //   lastDataTimestamp,
  //   dataStatus,
  // });

  return dataStatus;
};

const getStatusEngine = (
  currentLastDataRpm: any,
  dataSource: 'GSM' | 'SATELLITE',
  filter?: ILogReportFilter & { timezone: number }
) => {
  let isEngineOn: boolean = false;

  let currentTime = dayjs().unix();
  let lastDataTime = null;

  if (currentLastDataRpm && Object.keys(currentLastDataRpm).length) {
    lastDataTime = Number(Object.keys(currentLastDataRpm)[0]);
  }

  if (!lastDataTime) {
    return false;
  }

  if (filter) {
    const dateNow = dayjs().utcOffset(filter.timezone * 60).date();
    const filterStartDate = dayjs(filter.startAt * 1000)
      .utcOffset(filter.timezone * 60)
      .date();

    if (dateNow !== filterStartDate) {
      currentTime = dayjs(lastDataTime * 1000).unix();
    }
  }

  const isNotMoreThanTwoHours = currentTime - lastDataTime <= 7200;
  const isNotMoreThanTenMinutes = currentTime - lastDataTime <= 600;
  const totalRPM: any = (Object.values(currentLastDataRpm)[0] as any).totalRpm;

  if (dataSource === 'SATELLITE') {
    isEngineOn = isNotMoreThanTwoHours && totalRPM > 0;
  } else {
    isEngineOn = isNotMoreThanTenMinutes && totalRPM > 0;
  }

  // console.log('engine status', {
  //   dataSource,
  //   currentTime,
  //   lastDataTime,
  //   curr: currentTime - lastDataTime,
  //   totalRPM,
  // });

  return isEngineOn;
};

const renderMarkup = (data: {
  assetName: string;
  vesselStatus: VesselStatus;
  showVesselOnline: boolean;
  showVesselOffline: boolean;
  showVesselWaiting: boolean;
}) => {
  return `
    <div style="display: flex; align-items: center; flex-direction: column;">
      ${
        data.showVesselOnline && data.vesselStatus === VesselStatus.ONLINE
          ? `<img src="images/vessel-online.svg" alt="Vessel Online" width="45" height="45" />`
          : ''
      }
      ${
        data.showVesselOffline && data.vesselStatus === VesselStatus.OFFLINE
          ? `<img src="images/vessel-offline.svg" alt="Vessel Offline" width="45" height="45" />`
          : ''
      }
      ${
        data.showVesselWaiting &&
        data.vesselStatus === VesselStatus.WAITING_DATA
          ? `<img src="images/vessel-waiting-data.svg" alt="Vessel Waiting" width="45" height="45" />`
          : ''
      }
    </div>
  `;
};

export { VesselStatus, getVesselStatus, getStatusEngine, renderMarkup };
